import mixpanel, { type Dict } from "mixpanel-browser";

type UseMixpanelType = [
  (event_name: string, properties?: Dict) => Promise<void>,
  (unique_id?: string) => Promise<void>,
];
export default function useMixpanel(): UseMixpanelType {
  const MIXPANEL_APIKEY: string = import.meta.env.VITE_MIXPANEL_APIKEY;

  const track = async (event_name: string, properties?: Dict) => {
    if (MIXPANEL_APIKEY) {
      mixpanel.track(event_name, properties);
    }
  };

  const identify = async (unique_id?: string) => {
    if (MIXPANEL_APIKEY) {
      mixpanel.identify(unique_id);
    }
  };

  return [track, identify];
}
